import { hasPlugin as hasPluginInPlugins } from "./../wix-ricos-common";
import { VERTICAL_EMBED_TYPE } from "./../ricos-content";
import { verticalEmbedViewerStrategy } from "./verticalEmbedViewerStrategy/verticalEmbedViewerStrategy";
const runViewerStrategies = (plugins, baseUrl, previewMode) => {
  const hasPlugin = (pluginType) => hasPluginInPlugins(pluginType, plugins);
  return baseUrl && hasPlugin(VERTICAL_EMBED_TYPE) ? verticalEmbedViewerStrategy(baseUrl, previewMode) : { config: {} };
};
export {
  runViewerStrategies
};
//# sourceMappingURL=runViewerStrategies.js.map
